// ViaCEP por fetch: o axios do app leva o cabeçalho global do ngrok (main.js), que o ViaCEP recusa no CORS.
export async function consultarCep(cep) {
  const digits = String(cep || '').replace(/\D/g, '')
  if (digits.length !== 8) throw new Error('Informe um CEP com 8 dígitos.')
  const response = await fetch(`https://viacep.com.br/ws/${digits}/json/`)
  if (!response.ok) throw new Error('Não foi possível consultar o CEP.')
  const data = await response.json()
  if (data.erro) throw new Error('CEP não encontrado.')
  return data
}
